import { render, staticRenderFns } from "./NewTaskPage.vue?vue&type=template&id=762d8490&scoped=true"
import script from "./NewTaskPage.vue?vue&type=script&lang=js"
export * from "./NewTaskPage.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "762d8490",
  null
  
)

export default component.exports